export default "__VITE_ASSET__dvxkY60N__"